"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=pausable.js.map